import type { ReactNode } from 'react';
import { fieldError } from './Field.css';

export function FieldError({ children }: { children: ReactNode }) {
  return <p className={fieldError} role="alert">{children}</p>;
}
